import React from "react";
import byExpert from "../../images/not-by-ai.svg";

const containerStyle = {
  textAlign: 'right',
    cursor: 'pointer'
};

function NotByAI() {

    const info = () => {
        alert("All our blog posts are written by domain experts - developers, software engineers, and product managers. We don't use AI or copywriters to create content for our readers.");
    }

  return (
    <div style={containerStyle} onClick={info}>
      <img src={byExpert} className="notByAI"/>
    </div>
  );
}

export default NotByAI;
